// extracted by mini-css-extract-plugin
export default {"arrow":"xUeEwuejmb7m3MgtAzMkeg==","title":"oOTYA1pDcQlsqHJ1Kto5Uw==","body":"XXpCZC0W8e6aAVYhC6FX0g==","root":"_7L9M8CRuhsFf1dSKcLO8Ew=="};